import React from 'react';
import { Spin } from 'antd';
import {
	ContainerRidProps,
	CoreExtensionSlotParams,
	CreateReviewApprovalProps,
	NewVersionProps,
} from './types';

/**
 * Does not need to use React suspense since this is not intended to be user facing
 */
export const LazyDevPage = React.lazy(() => import('./DevPage'));

const LazyExistingReviewApprovalSPDrawerExtensionSlot = React.lazy(
	() => import('./ExistingReviewApprovalSPDrawer')
);
export const AsyncExistingReviewApprovalSPDrawerExtensionSlot: React.FC<
	CoreExtensionSlotParams<ContainerRidProps>
> = props => {
	return (
		<React.Suspense fallback={<Spin />}>
			<LazyExistingReviewApprovalSPDrawerExtensionSlot {...props} />
		</React.Suspense>
	);
};

const LazyCreateReviewApprovalDrawerExtensionSlot = React.lazy(
	() => import('./CreateReviewApprovalDrawer')
);
export const AsyncCreateReviewApprovalDrawerExtensionSlot: React.FC<
	CoreExtensionSlotParams<CreateReviewApprovalProps>
> = props => {
	return (
		<React.Suspense fallback={<Spin />}>
			<LazyCreateReviewApprovalDrawerExtensionSlot {...props} />
		</React.Suspense>
	);
};

const LazyCreateReviewApprovalFromStoragePiletDrawerExtensionSlot = React.lazy(
	() => import('./CreateReviewApprovalDrawerFromStoragePilet')
);
export const AsyncCreateReviewApprovalFromStoragePiletDrawerExtensionSlot: React.FC<
	CoreExtensionSlotParams<ContainerRidProps>
> = props => {
	return (
		<React.Suspense fallback={<Spin />}>
			<LazyCreateReviewApprovalFromStoragePiletDrawerExtensionSlot {...props} />
		</React.Suspense>
	);
};

const LazyCreateNewVersionModalExtensionSlot = React.lazy(
	() => import('./CreateNewVersionModal')
);
export const AsyncCreateNewVersionModalExtensionSlot: React.FC<
	CoreExtensionSlotParams<NewVersionProps>
> = props => {
	return (
		<React.Suspense fallback={<Spin />}>
			<LazyCreateNewVersionModalExtensionSlot {...props} />
		</React.Suspense>
	);
};
